import React, { createContext, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const JobModalContext = createContext(null);

export function JobModalProvider({ children }) {
  const navigate = useNavigate();

  const openJobModal = useCallback((opts = {}) => {
    try { sessionStorage.setItem("ss_prefill", JSON.stringify(opts)); } catch (e) {}
    navigate("/post-job", { state: opts });
  }, [navigate]);

  return (
    <JobModalContext.Provider value={{ openJobModal }}>
      {children}
    </JobModalContext.Provider>
  );
}

export function useJobModal() {
  const ctx = useContext(JobModalContext);
  if (!ctx) return { openJobModal: () => {} };
  return ctx;
}
